import { LARGE } from './breakpoint-controller';

var interfaceController = (function($) {
	var interfaceActions = {
		// Init global properties and actions: run on page ready
		init: function() {
			this.equalHeights();
			this.toggleTouchState();
			this.comparisonTable();
			this.tabTriggers();
		},

		/**
		 * Given an element with a data attribute of data-match-height, set all
		 * children of this element specified by the attribute value to that height
		 * of the specified CSS selector
		 */
		equalHeights: function() {
			var equalHeightParents = $('[data-match-height]');
			if (equalHeightParents.length > 0) {
				$(window).on('load resize', function() {
					equalHeightParents.each(function() {
						var elementCollection = $(this).find($(this).attr('data-match-height'));

						// Get all heights for this child/parent combo
						var elementHeights = elementCollection
							.map(function() {
								$(this).css('height', '');
								return $(this).height();
							})
							.get();

						// Pluck the highest height. It's our master
						var maxHeight = Math.max.apply(null, elementHeights);

						// Set the other elements in the collection to this height
						if (maxHeight && maxHeight > 0) {
							elementCollection.height(maxHeight);
						}
					});
				});
			}
		},

		/**
		 * Given an element with a toggle state defined by class 'toggle-state',
		 * activate an on/off toggle of an active class
		 */
		toggleTouchState: function() {
			var toggleItems = $('.toggle-state');
			if (toggleItems.length > 0) {
				toggleItems.on('click', function() {
					$(this).toggleClass('active');
					toggleItems.not(this).removeClass('active');
				});
			}
		},

		/**
		 * Comparison table; activate mobile UI
		 */
		comparisonTable: function() {
			if ($('section.product_comparison_table').length > 0) {
				$(window).on('load resize', function() {
					if (Modernizr.mq('(max-width: ' + LARGE + 'px)')) {
						$('li.switcher').off('click').on('click', function() {
							var currentTab = $(this).attr('class').split(' ').pop();
							$('li.switcher').removeClass('active');
							$(this).addClass('active');
							$('li.feature-status').hide();
							$('li.feature-status.' + currentTab).attr('style', '');
							$('.product-link').hide();
							$('.product-link.' + currentTab).show();
						});
						if (!$('li.switcher').first().hasClass('active')) {
							$('li.switcher').first().trigger('click');
						}
						$('.product-links-mobile').show();
					} else {
						$('.product-links-mobile').hide();
						$('li.feature-status').attr('style', '');
						$('li.switcher').removeClass('active');
					}
				});
			}
		},

		/**
		 * Tabbed content interfaces: activate UI
		 */
		tabTriggers: function() {
			$('section.tab-switcher').each(function() {
				var triggerElements = $(this).find('.tab-nav>.tab-trigger');
				triggerElements.on('click', function() {
					$(this).siblings().removeClass('active');
					$(this).addClass('active');
					$(this).closest('.tab-switcher').find('.tab').removeClass('active').hide();
					$(this).closest('.tab-switcher').find('.tab.' + $(this).attr('data-tab-trigger')).show().addClass('active');
				});
				triggerElements.first().trigger('click');
			});
		}
	};

	return interfaceActions;
})(jQuery);

jQuery(document).ready(function() {
	interfaceController.init();
});
